<template>
  <v-container fluid class="max-width">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Products</v-toolbar-title>
        <v-spacer></v-spacer>
       <v-btn v-show="subscriberId == 1" color="accent" small @click="syncFromDynamics" text>
          <v-icon left dark>mdi-sync</v-icon> Sync From Dynamics
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row class="mt-2">
          <v-col cols="12">
            <v-btn color="primary" small to="/new-product">
              <v-icon left dark>mdi-plus</v-icon>New Product
            </v-btn>
          </v-col>

          <v-col cols="12" v-show="ExportsVersion != 'Y'">
            <v-btn class="float-right" color="accent" text @click="syncProductsToEtims">
              <v-icon left dark></v-icon>Sync Products To Etims
            </v-btn>

            <v-btn class="float-right" color="primary" text @click="generateEtimsNumbers">
              <v-icon left dark></v-icon> Generate Etims Numbers
            </v-btn>

            <v-btn class="float-right" color="accent" text to="/generate-barcodes">
              <v-icon left dark></v-icon> Generate Barcodes
            </v-btn>
          </v-col>
          
        </v-row>

        
        <v-row>
          <v-text-field v-model="search" @input="onSearchInput" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" sm="12" md="12">
            <!-- excel icon -->
            <download-excel :data="products" :fields="fields" name="Products List">
              <v-icon color="green">mdi-file-excel</v-icon>
            </download-excel>
            <!-- end -->
            <!-- start of table -->
            <v-data-table
              :loading="loader"
              :mobile-breakpoint="0"
              loading-text="Loading Products........"
              :headers="ExportsVersion == 'Y' ? exportHeaders : headers"
              :items="products"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              :footer-props="{
                'items-per-page-options': [25, 50, 100]
              }">

              <!-- action template -->
              <template v-slot:item.hasInventory="{ item }">
                <span v-if="item.hasInventory == 'yes'" style="color: blue">{{ item.hasInventory }}</span>
                <span v-if="item.hasInventory == 'no'" style="color: red">{{ item.hasInventory }}</span>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.Name="{ item }">
                <v-btn color="editIcon" text :to="`/product/${item.id}`"> {{ item.Name }}
                </v-btn>
              </template>
              <!-- end -->

              <!-- owner template -->
              <template v-slot:item.Owner="{ item }">
                <v-span v-if="item.Owner == 248"> Amaya </v-span>
                <v-span v-else></v-span>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/product/${item.id}`" icon><v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.print="{ item }">
                <v-btn color="accent" text :to="`/product-barcode/${item.id}`"><v-icon>mdi-print</v-icon> Print Barcode
                </v-btn>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.deleteProduct="{ item }">
                <v-btn color="red" @click="openDeleteModal(item)" text><v-icon left>mdi-close</v-icon> Disable Product
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <!-- product dialog modal-->
        <v-dialog v-model="deleteDialog" max-width="750px">
          <v-card>
            <v-toolbar dense color="secondary" flat>
              <v-toolbar-title> Delete / Disable Product </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="deleteDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row class="text--primary subtitle-2">
                  <v-col cols="12">
                    Are you sure you want to delete / disable this product?
                  </v-col>
                  <v-col cols="12">
                    <span style="font-size: 20px">{{ productItem.Name }}</span>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="red" dark :loading="loader" @click="deleteProduct">Yes, Disable</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of modal-->
      </v-card-text>
    </v-card>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  computed: {
    ExportsVersion() {
      return localStorage.getItem("ExportsVersion");
    },
    IsDistributor() {
      return localStorage.getItem("IsDistributor");
    },
    subscriberId() {
      return localStorage.getItem("subscriber_id");
    },
    storeId() {
      return localStorage.getItem("store_id");
    },
  },
  data: () => ({
    search: "",
    IsDigrio: "N",
    deleteDialog: false,
    productItem: {},
    loader: false,
    searchTimeout: null,
    // Server-side pagination
    serverItemsLength: 0,
    options: {},
    headers: [
      { text: "Item Code", value: "ItemCode" },
      { text: "Product Name", value: "Name" },
      { text: "Brand", value: "brand.Name" },
      { text: "Category", value: "category.Name" },
      // { text: "Etims Code", value: "itemCd" },
      // { text: "Description", value: "Description" },
      { text: "Barcode", value: "BarCode" },
      // { text: "Has Inventory", value: "hasInventory" },
      // { text: "Owner", value: "Owner" },
      { text: "Print", value: "print" },
      { text: "Action", value: "action" },
      { text: "Delete", value: "deleteProduct" },
    ],
    exportHeaders: [
      { text: "HS Code", value: "ItemCode" },
      { text: "Product Name", value: "Name" },
      { text: "Category", value: "category.Name" },
      { text: "Action", value: "action" },
      { text: "Delete", value: "deleteProduct" },
    ],
    products: [],
    fields: {
      ItemCode: "ItemCode",
      CustomCode: "CustomPrefixNumber",
      Product: "Name",
      Barcode: "BarCode",
      BaseUnit: "baseUnit",
    },
  }),
  watch: {
    options: {
      handler() {
        this.getProducts();
      },
      deep: true,
    },
  },
  methods: {
    onSearchInput() {
      // Debounce search to avoid too many requests
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.options.page = 1; // Reset to first page on search
        this.getProducts();
      }, 500);
    },
    openDeleteModal(data) {
      this.productItem = data;
      this.deleteDialog = true;
    },
    generateCustomNumbers() {
      // this.$store.commit("btnLoader", false);
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("get", `/generate-custom-numbers/${this.subscriberId}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.getProducts();
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    generateBarcodes() {
      // this.$store.commit("btnLoader", false);
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("get", `/generate-barcodes/${this.subscriberId}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.getProducts();
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getProducts() {
      this.$store.commit("btnLoader", false);
      const self = this;
      this.loader = true;

      const { page, itemsPerPage } = this.options;
      const pageNumber = page || 1;
      const pageSize = itemsPerPage || 50;

      // Build query params
      let params = `page=${pageNumber}&pageSize=${pageSize}`;
      if (this.search) {
        params += `&search=${encodeURIComponent(this.search)}`;
      }

      this.$store
        .dispatch("get", `/products?${params}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData.products || [];
            self.serverItemsLength = res.ResponseData.total || 0;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.loader = false;
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
          self.loader = false;
        });
    },
    deleteProduct() {
      const url = `/delete/product/${this.productItem.id}`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("remove", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            location.reload();
          } else {
            self.loader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          self.$refs.snackbar.show(err, "red");
        });
    },
    generateEtimsNumbers() {
      this.loader = true;
      const self = this;
      var url = `/generate-etims-numbers/${this.subscriberId}`
      this.$store
        .dispatch("get", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    syncProductsToEtims() {
      this.loader = true;
      const self = this;
      var url = `/sync-products-to-etims`
      this.$store
        .dispatch("get", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
     syncFromDynamics() {
      this.loader = true;
      const self = this;
      var url = `/sync-business-central-products/${this.subscriberId}/${this.storeId}`
      
      this.$store
        .dispatch("get", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
             this.$refs.snackbar.show("Products synced successfully", "green");
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
     getGeneralSettings() {
      this.loader = true;
      const self = this;
      var url = `/general-settings`
      this.$store
        .dispatch("get", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.IsDigrio = res.ResponseData.IsDigrio;
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getGeneralSettings();
  },
};
</script>